import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const PhoneIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.17 3.33h3.33l1.67 4.17-2.5 1.67a10 10 0 0 0 4.17 4.17l1.67-2.5 4.17 1.67v3.33a1.67 1.67 0 0 1-1.67 1.67A13.33 13.33 0 0 1 2.5 5a1.67 1.67 0 0 1 1.67-1.67"></path>
      </svg>
    </Icon>
  </>
)
